import React from 'react'
import Profile from './Profile'

/**
 * users = instance of \WP Users
 */
const TinyProfiles = ({ users }) => {
    let toDisplayUsers = users.slice(0, 4)     //max is 4 content
    
    return (
        <>
            <div className='msync-tiny-profiles'>
                {
                    toDisplayUsers.length !== 0 ?
                        toDisplayUsers.map((user, key) => {
                            let alt = user.data.user_nicename.slice(0, 2).toUpperCase()

                            if(key === 3){
                                const remainingUsers = users.length - 4
                                alt = remainingUsers === 0 ? alt : `+${remainingUsers}`
                            }

                            return(
                                <Profile
                                    key={key}
                                    radius={'radius-rounded'}
                                    size={'25px'}
                                    alt={alt}
                                    fontSize={'10px'}
                                />
                            )
                        })
                    : 
                    <p>None</p>
                }
            </div>
        </>
    )
}

export default TinyProfiles